import { Link } from "react-router-dom";
import { Button } from "@odingard/design-system";
import { usePageMeta } from "../../lib/usePageMeta";

const CAPS = [
  { icon: "📥", title: "Ingestion & extraction", body: "OCR, classify, and extract key terms with confidence scores and source citations on every field." },
  { icon: "✦", title: "AI review queue", body: "Extractions the model is unsure of surface for human verification. Nothing is trusted blindly." },
  { icon: "💬", title: "Ask Your Contracts", body: "Grounded portfolio Q&A. If there's no supporting evidence, Contract AI declines rather than guessing." },
  { icon: "⚖️", title: "Clause intelligence", body: "Risk playbooks flag unlimited liability, missing confidentiality, indemnification gaps, and more." },
  { icon: "🏛️", title: "Government contracting", body: "FAR/DFARS libraries, flow down engine, option years, and periods of performance." },
  { icon: "🛡️", title: "Compliance evidence", body: "Cited, checksummed CMMC and DCAA evidence packs with immutable verification history." },
];

export function ContractAIMarketing() {
  usePageMeta({
    title: "Contract AI | the contract system of record",
    description: "Ingest, extract and review contracts with grounded AI: obligations, renewals, clause intelligence and cited compliance evidence.",
    path: "/contract-ai",
  });
  return (
    <>
      <section className="hero">
        <div className="container">
          <span className="hero__eyebrow">Contract AI</span>
          <h1>Understand every contract. Prove every answer.</h1>
          <p className="lede">
            Contract AI reads your agreements, extracts the terms that matter, flags risk against your playbooks,
            and answers questions with citations, never ungrounded guesses.
          </p>
          <div className="ods-row">
            <Link to="/start">
              <Button size="lg">Start free trial</Button>
            </Link>
            <Link to="/pricing">
              <Button variant="secondary" size="lg">
                See pricing
              </Button>
            </Link>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="feature-grid">
            {CAPS.map((c) => (
              <div className="feature" key={c.title}>
                <div className="feature__icon" aria-hidden="true">
                  {c.icon}
                </div>
                <h3>{c.title}</h3>
                <p>{c.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
